import { handleActions } from "redux-actions";
import Swal from 'sweetalert2';
import { apiDriverApp } from "../../libs/apiDriverApp";
import XLSX from 'xlsx';
import Toast from "../../utility/Toast";


const errorHandler = (error, swalOptions) => {
    console.error(error);
    const { response } = error;
    let errors  = '';

    if (!response) {
        errors = error.message || 'Network error — please check your connection and try again.';
    } else if (response.data.error || response.data.detail) {
        errors = response.data.error || response.data.detail;
    } else {
        if (response.data instanceof Array) {
            for(const row in response.data) {
                for(const field in response.data[row])
                    errors += `${errors ? '<br/>' : ''}${row} row - ${field}: ${response.data[row][field]}`;
            }
        } else {
            for (const field in response.data)
                errors += `${errors ? '<br/>' : ''}${field}: ${response.data[field]}`
        }
    }

    let message = errors || `Something went wrong`;
    return Swal.fire({
        title: "Error",
        html: message,
        type: "error",
        confirmButtonText: "OK",
        confirmButtonColor: "#D50032",
        ...swalOptions,
    });
}

const VENDOR_LOADING = "VENDOR_LOADING";
const DRIVERS_LIST_LOADING = "DRIVERS_LIST_LOADING";
const DRIVER_LOADING = "DRIVER_LOADING";
const VENDOR_DATA = "VENDOR_DATA";
const DRIVERS_PAGE = "DRIVERS_PAGE";
const VENDORS_DRIVERS = "VENDORS_DRIVERS";
const DRIVERS_FILTERS = "DRIVERS_FILTERS";

// Pure Actions
const setLoading = (loading_vendor) => ({
    type: VENDOR_LOADING,
    loading_vendor
});

const setDriversLoadingList = (loading_list_drivers) => ({
    type: DRIVERS_LIST_LOADING,
    loading_list_drivers,
})

const setVendor = (vendor) => ({
    type: VENDOR_DATA,
    vendor
})

const setPage = (drivers_page) => ({
    type: DRIVERS_PAGE,
    drivers_page,
})

const setVendorDrivers = (drivers) => ({
    type: VENDORS_DRIVERS,
    drivers
})

const setDriverFilter = (driver_filters) => ({
    type: DRIVERS_FILTERS,
    driver_filters
})

const setDriverLoading = (driver_loading) => ({
    type: DRIVER_LOADING,
    driver_loading,
})

//Actions
export const loadVendor = (id) => async (dispatch, getState) => {
    dispatch(setLoading(true));
    try {
        const response = await apiDriverApp.get(`api/vendors/vendors/${id}/`);
        dispatch(setVendor(response.data));
        return response;
    } catch(error) {
        errorHandler(error);
    } finally {
        dispatch(setLoading(false));
    }
};

export const updateVendor = (id, data) => async (dispatch) => {
    dispatch(setLoading(true));
    try {
        const response = await apiDriverApp.patch(`api/vendors/vendors/${id}/`, data);
        dispatch(setVendor(response.data));
        Toast.success('Vendor updated successfully');
        return response;
    } catch (error) {
        errorHandler(error);
    } finally {
        dispatch(setLoading(false));
    }
}

export const setDriverFilters = (filters) => (dispatch) => {
    dispatch(setDriverFilter(filters));
    dispatch(loadDrivers());
}

export const loadDrivers = (params, page = 1) => async (dispatch, getState) => {
    dispatch(setDriversLoadingList(true));
    const { driver_filters: filters, vendor } = getState().vendors;
    const requestParams = {
        vendor_id: vendor && vendor.id,
        page,
    }
    if(filters.search)
        requestParams.search = filters.search;

    if (filters.status && filters.status != 'all')
        requestParams.active = filters.status == 'active';

    if (filters.role && filters.role != 'all')
        requestParams.role = filters.role;
    try {
        const response = await apiDriverApp.get(`api/vendors/vendor-users`, {
            params: { ...requestParams, ...params },
        });
        dispatch(setVendorDrivers(response.data));
        dispatch(setPage(page))
        return response;
    } catch (error) {
        errorHandler(error);
    } finally {
        dispatch(setDriversLoadingList(false));
    }
}

export const addDriver = (data) => async (dispatch, getStore) => {
    dispatch(setDriverLoading(true));
    try {
        const response = await apiDriverApp.post(`api/vendors/vendor-users/`, data);
        const { vendor } = getStore().vendors;
        dispatch(loadVendor(vendor.id))
        Toast.success(response.data.message || `Invite sent to ${data.email}`);
        dispatch(loadDrivers());
        return response;
    } catch(error) {
        errorHandler(error);
    } finally {
        dispatch(setDriverLoading(false));
    }
}

export const updateDriver = (id, data) => async (dispatch) => {
    dispatch(setDriverLoading(true));
    try {
        const response = await apiDriverApp.patch(`api/vendors/vendor-users/${id}/`, data);
        Toast.success(response.data.message || `Driver updated successfully`);
        dispatch(loadDrivers());
        return response;
    } catch(error) {
        errorHandler(error);
    } finally {
        dispatch(setDriverLoading(false));
    }
}

export const resendInviteDriver = (id) => async (dispatch) => {
    dispatch(setDriverLoading(true));
    try {
        const response = await apiDriverApp.post(`api/vendors/vendor-users/${id}/resend-invite/`);
        Toast.success(response.data.message || 'Invite sent successfully');
        return response;
    } catch (error){
        errorHandler(error);
    } finally {
        dispatch(setDriverLoading(false));
    }
}

export const resetDriverPassword = (data) => async (dispatch) => {
    dispatch(setDriverLoading(true));
    try {
        const response = await apiDriverApp.post(`api-auth/admin/reset-password-requirement/`, data);
        Toast.success(response.data.message || 'Password successfully reset');
        return response;
    } catch (error) {
        errorHandler(error);
    } finally {
        dispatch(setDriverLoading(false));
    }
}

export const changeDriverStatus = (id, active) => async (dispatch) => {
    dispatch(setDriversLoadingList(true));
    try {
        const response = await apiDriverApp.patch(`api/vendors/vendor-users/${id}/`, { active })
        dispatch(loadDrivers());
        if (active)
            Toast.success(response.data.message || `User has been activaded`);
        else
            Toast.warning(response.data_message || `User has been deactivated`);
        return response;
    } catch(error) {
        errorHandler(error);
    } finally {
        dispatch(setDriversLoadingList(false));
    }
}

export const exportToCsvOrExcel = (type='csv', useFilters=true) => async (dispatch, getState) => {
    dispatch(setDriversLoadingList(true));
    try {
        const { driver_filters: filters, vendor } = getState().vendors;
        const requestParams = {
            vendor_id: vendor && vendor.id,
        }
        if (useFilters) {
            if(filters.search)
                requestParams.search = filters.search;
    
            if (filters.status && filters.status != 'all')
                requestParams.active = filters.status == 'active';
    
            if (filters.role && filters.role != 'all')
                requestParams.role = filters.role;
        }

        const response = await apiDriverApp.get(`api/vendors/vendor-users/export-${type == 'csv' ? 'csv' : 'excel'}/`, {
            params: requestParams,
            responseType: 'blob',
        });

        const blob = new Blob([response.data]);
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `vendor-users.${type == 'csv' ? 'csv' : 'xlsx'}`;
        link.click();
        Toast.success(`${type == 'csv' ? 'CSV' : 'Excel file'} exported successfully`)
        return true;
    } catch (error) {
        errorHandler(error);
    } finally {
        dispatch(setDriversLoadingList(false));
    }
}

export const downloadTemplate = (type = 'csv') => async (dispatch) => {
    try {
        if (type === 'csv') {
            var csv = "first_name,last_name,email,role,user_type,mobile_phone,work_email,device_type" + '\n'
            csv += 'Jane,Smith,jane@example.com,driver,false,555-0100,jane@work.com,ios\n';
            var blob = new Blob([csv], { type: "text/csv" });
            var url = URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.href = url;
            a.download = "vendor_driver_import_template.csv";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        } else if (type === 'excel') {
            var wsData = [
                ["first_name","last_name","email","role","user_type","mobile_phone","work_email","device_type"],
                ['Jane', 'Smith', 'jane@example.com', 'driver', 'false', '555-0100', 'jane@work.com', 'ios']
            ];
            var ws = XLSX.utils.aoa_to_sheet(wsData);
            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Import Template');
            XLSX.writeFile(wb, 'vendor_driver_import_template.xlsx');
        }
        Toast.success('Template downloaded')
    } catch (error) {
        errorHandler(error);
    }
}

export const importDriversList = (drivers_list = []) => async (dispatch, getStore) => {
    dispatch(setDriverLoading(true));
    try {
        const response = await apiDriverApp.post(`api/vendors/vendor-users/`, drivers_list)
        dispatch(loadDrivers());
        Toast.success(`${drivers_list.length} drivers imported successfully. Invite emails will be sent.`)
        return response;
    } catch (error) {
        errorHandler(error);
    } finally {
        dispatch(setDriverLoading(false));
    }
}

// Reducers
const reducers = {
    [VENDOR_LOADING]: (state, { loading_vendor }) => ({ ...state, loading_vendor }),
    [DRIVERS_LIST_LOADING]: (state, { loading_list_drivers }) => ({ ...state, loading_list_drivers }),
    [DRIVER_LOADING]: (state, { driver_loading }) => ({ ...state, driver_loading }),
    [VENDOR_DATA]: (state, { vendor }) => ({ ...state, vendor }),
    [DRIVERS_PAGE]: (state, { drivers_page }) => ({ ...state, drivers_page }),
    [VENDORS_DRIVERS]: (state, { drivers }) => ({ ...state, drivers }),
    [DRIVERS_FILTERS]: (state, { driver_filters }) => ({ ...state, driver_filters }),
};

export const initialState = {
    vendor: {},
    loading_vendor: false,
    loading_list_drivers: false,
    driver_loading: false,
    drivers_page: 1,
    driver_filters: {
        role: "all",
        status: "all",
        search: ""
    },
    drivers: {},
};

export default handleActions(reducers, initialState);
